import { ArrowUpRight } from "lucide-react";

const navCol = [
  { label: "Início", href: "/#hero" },
  { label: "Soluções", href: "/#capabilities" },
  { label: "Como funciona", href: "/#how" },
  { label: "Sistemas legados", href: "/#legacy" },
  { label: "Contato", href: "/contato" },
];

const legalCol = [
  { label: "Privacidade", href: "/privacidade" },
  { label: "Termos de Uso", href: "/termos" },
  { label: "Exclusão de Dados", href: "/exclusao-de-dados" },
  { label: "Contato", href: "/contato" },
];

const contactCol = [
  { label: "contato@rodeia.com.br", href: "mailto:contato@rodeia.com.br" },
  { label: "suporte@rodeia.com.br", href: "mailto:suporte@rodeia.com.br" },
  { label: "privacidade@rodeia.com.br", href: "mailto:privacidade@rodeia.com.br" },
];

const Column = ({ title, links, testid }) => (
  <div data-testid={testid}>
    <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-neutral-600">
      {title}
    </span>
    <ul className="mt-5 space-y-3">
      {links.map((l) => (
        <li key={l.label}>
          <a
            href={l.href}
            className="text-neutral-400 hover:text-white text-sm transition-colors break-all"
          >
            {l.label}
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => {
  return (
    <footer className="relative border-t border-white/10 pt-20 pb-10" data-testid="main-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr_1.2fr] gap-12">
          <div>
            <div className="flex items-center gap-2">
              <span className="h-2.5 w-2.5 bg-white rounded-full" />
              <span className="font-display font-extrabold tracking-tight text-lg">
                RODE IA
              </span>
            </div>
            <p className="text-neutral-500 mt-5 max-w-[38ch] text-sm leading-relaxed">
              Automação de processos e integração de sistemas — inclusive
              legados — para operações que trabalham sozinhas.
            </p>
            <a
              href="/contato"
              className="mt-6 inline-flex items-center gap-1.5 text-white font-medium text-sm hover:gap-2.5 transition-all"
            >
              Mapear meu processo <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <Column title="Navegação" links={navCol} testid="footer-nav" />
          <Column title="Legal" links={legalCol} testid="footer-legal" />
          <Column title="Contato" links={contactCol} testid="footer-contato" />
        </div>

        <div className="mt-20 select-none">
          <div className="font-display font-extrabold tracking-tighter text-[15vw] leading-[0.8] text-white/[0.04]">
            RODE IA
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-neutral-600 text-xs font-mono">
          <span>
            © {new Date().getFullYear()} RODE IA LTDA · CNPJ 68.764.921/0001-64
          </span>
          <span>Processos · Integrações · Sistemas legados</span>
        </div>
      </div>
    </footer>
  );
};
